import { Injectable } from '@angular/core';
import { ServerService } from '../core/service/server.service';
import { ServiceDefault } from '../core/service/service-default';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService extends ServiceDefault {

  constructor(server: ServerService) {
    super('produto', server);
  }

  listSimple() {
    return this.get('list-simple');
  }

  importar() {
    return this.post('importar', {});
  }
}
